import { Component, computed, input } from '@angular/core';
import { type BadgeColor, type BadgeSize } from './badge.model';

@Component({
  selector: 'lib-badge',
  templateUrl: './badge.component.html',
  styleUrls: [
    '../../tokens/colors.css',
    '../../tokens/badge-tokens.css',
    './badge.component.css',
  ],
  host: {
    '[class]': 'hostClasses()',
  },
})
export class BadgeComponent {
  /** Badge text content. */
  label = input.required<string>();

  /** Semantic color variant. */
  color = input<BadgeColor>('blue');

  /** Size variant. */
  size = input<BadgeSize>('md');

  readonly hostClasses = computed(() => {
    const color = this.color();
    const size = this.size();
    return {
      'msa-badge': true,
      [`msa-badge--${color}`]: true,
      [`msa-badge--${size}`]: true,
    };
  });
}
